// extracted by mini-css-extract-plugin
export default {"ISO9001":"ISO9001_ISO9001__6aD+X"};